<template>
    <div>
        <div class="inner">
            <div class="title">
                <p>
                    {{ popupTitle }}
                </p>
            </div>
            <hr class="popupHr">
            <div class="introductionTxt">
                <h5>
                    {{ introductionTxt }}
                </h5>
                <section class="surveyArea">
                    
                </section>
            </div>
        </div>
    </div>
    
</template>
<script>
import axios from 'axios'

export default {
    data() {
        return {
            name : null,
            email : null,
            phoneCompany : null,
            phoneNumber : null,
            address : null,
            addressDetail : null,
            popupTitle: '한국 고령자 기술수용도 실태 조사',
            introductionTxt: '서울과 경기권에 거주하는 만 55세 이상의 중·고령자 457명을 대상으로 실시하는 설문조사',
        }
    },
    methods: {
        getUserInfo(){
            let paramDatas = this.$store.state.modal.paramDatas;
            axios.post('http://localhost:8080/test/getUserByIdx', paramDatas.idx)
            .then(response => {
                if(response.status == 200){
                    let userData = response.data.USER;
                    this.name = userData.name;
                    this.phoneCompany = userData.phoneCompany;
                    this.phoneNumber = userData.phoneNumber;
                    this.address = userData.address;
                    this.addressDetail = userData.addressDetail;
                }
            })
            .catch(() => {
            })
            .then(() => {
            });
        },
        doOkFunc(){
            console.log("hi")
        }
    },
    mounted: function(){
        this.getUserInfo();
    }
}
</script>